import { Navigate, useNavigate } from "react-router-dom";
import { useDataContext } from "../context/data";
import choices from "../utils/choice-keys";

const ProtectedRoute = ({ allowedRoles, element }) => {

  const { user } = useDataContext();
  const navigation = useNavigate()

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.user_type)) {

    return <Navigate to="/unauthorized" replace />

  }

  return element
};

export default ProtectedRoute;
